module.exports = "<!-- a routerLink=\"/entrenador\">Enlace provisional</a -->\r\n<!-- router-outlet></router-outlet -->\r\n<app-principal></app-principal>\r\n"